<template>
  <div class="invoice">
    <div class="row">
      <div class="col-7">
        <div class="image">
          <Image_Swiper_Set height="85dvh" width="60dvw" :status="status" />
        </div>
      </div>
      <div class="col-5" style="height: 95dvh !important">
        <AddPhoneNumber
          :initialPhoneNumber="phoneNumber"
          @phone-number-added="handlePhoneNumberAdded"
          @update-status="updateStatus"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Image_Swiper_Set from "@/components/Image_Swiper_Set.vue";
import AddPhoneNumber from "@/components/AddPhoneNumber.vue";

export default {
  mixins: [], //common script
  components: {
    AddPhoneNumber,
    Image_Swiper_Set,
  },
  data() {
    return {
      status: "re_phone_no",
    };
  },
  methods: {
    updateStatus(newStatus) {
      this.$emit("update-status", newStatus);
    },
  },
};
</script>

<style scoped>
.invoice {
  background: #100d08;
  border-color: rgba(255, 250, 250, 0);
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.image {
  margin-left: 2dvh;
  margin-bottom: 0dvh;
  margin-top: 2dvh;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  border-radius: 5px;
  height: 90dvh;
}

.block {
  padding: 5px;
  height: 15dvh;
  margin-top: 3dvh;
  justify-content: center;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.name {
  font-size: 2dvh;
  color: #ffffff;
  text-overflow: ellipsis;
  margin-left: 7px;
  margin-top: 1dvh;
  align-items: center;
  font-weight: bold;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.bold-text {
  margin-left: 6px;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.current-time {
  font-size: 14px;
  color: #ffffff;
  margin-right: 40px;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.main-table {
  margin-right: 2dvw;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 70dvh;
  border-radius: 2rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

thead,
tfoot {
  display: table;
  width: 100%;
  table-layout: fixed;
  position: relative;
  background-color: #ffffff;
}

tbody {
  display: block;
  height: 40dvh;
  overflow-y: auto;
  overflow-x: hidden;
}

tbody.product-line::-webkit-scrollbar {
  width: 5px;
}

tbody.product-line::-webkit-scrollbar-thumb {
  background-color: #888;
}

tbody.product-line::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

tbody.product-line tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

tfoot tr {
  display: table;
  width: 100%;
  table-layout: auto;
}

.final_total {
  font-size: 3dvh;
  margin-left: 2dvw;
  margin-right: 2dvw;
  margin-bottom: 1dvh !important;
  text-align: center;
  color: rgb(255, 255, 255);
  position: relative;
}

.address {
  white-space: pre-line;
}
</style>
